import { auth } from '../../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { v4 as uuidv4 } from 'uuid';

const triggerWeeklyDealSummary = (
  orgId,
  dealId,
  summaryWindow,
  callback,
  errCb,
) => {
  return async (dispatch) => {
    dispatch({ type: 'TRIGGERING_WEEKLY_DEAL_SUMMARY' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/weekly-deal-summary/trigger`,
            null,
            {
              params: {
                'request-id': reqId,
                orgId: orgId,
                dealId: dealId,
                summaryWindow: summaryWindow,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'TRIGGERING_WEEKLY_DEAL_SUMMARY_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'TRIGGERING_WEEKLY_DEAL_SUMMARY_FAILED',
              payload: `Failed to trigger weekly deal summary`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'TRIGGERING_WEEKLY_DEAL_SUMMARY_FAILED',
            payload: `Failed to trigger weekly deal summary`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'TRIGGERING_WEEKLY_DEAL_SUMMARY_FAILED',
        payload: `Failed to trigger weekly deal summary`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default triggerWeeklyDealSummary;
